import React from 'react';
import AppDropdown from '../AppDropdown';
import AppToggle from '../AppToggle';

export default function TaxationCard({ 
  value = {}, 
  onChange,
  onGstVerifyClick 
}) {
  const patch = (field, val) => {
    if (onChange) {
      onChange({ ...value, [field]: val });
    }
  };

  const typeOptions = [
    { value: 'Regular', label: 'Regular' },
    { value: 'Composition', label: 'Composition' },
    { value: 'Unregistered', label: 'Unregistered' },
    { value: 'Consumer', label: 'Consumer' }
  ];

  const stateOptions = [
    { value: 'Maharashtra', label: 'Maharashtra' },
    { value: 'Karnataka', label: 'Karnataka' },
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Gujarat', label: 'Gujarat' }
  ];

  const transporterOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'V-Trans', label: 'V-Trans' },
    { value: 'BlueDart', label: 'BlueDart' }
  ];

  const tdsOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'Applicable', label: 'Applicable' },
    { value: 'Not Applicable', label: 'Not Applicable' }
  ];

  const tdsCodeOptions = [
    { value: 'Select', label: 'Select' },
    { value: '194C', label: '194C - Contractor' },
    { value: '194J', label: '194J - Professional' }
  ];

  const tcsOptions = [
    { value: '0%', label: '0%' },
    { value: '0.1%', label: '0.1%' },
    { value: '1%', label: '1%' }
  ];

  const msmeTypeOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'Micro', label: 'Micro' },
    { value: 'Small', label: 'Small' },
    { value: 'Medium', label: 'Medium' }
  ];

  const categoryOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'Manufacturer', label: 'Manufacturer' },
    { value: 'Trader', label: 'Trader' },
    { value: 'Service Provider', label: 'Service Provider' }
  ];

  const residentOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'Resident', label: 'Resident' },
    { value: 'Non-Resident', label: 'Non-Resident' }
  ];

  const currencyOptions = [
    { value: 'INR', label: 'INR' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' }
  ];

  const ledgerOptions = [
    { value: 'None', label: 'None' },
    { value: 'Main', label: 'Main Ledger' },
    { value: 'Sub', label: 'Sub Ledger' }
  ];

  return (
    <div className="rounded-2xl border border-outline-variant/30 bg-surface-container-lowest overflow-hidden shadow-xs">
      {/* Header */}
      <div className="bg-surface-container-low/60 px-6 py-3 border-b border-outline-variant/25 text-sm font-bold text-on-surface">
        Taxation
      </div>

      {/* Main Container: two columns */}
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
        
        {/* Left Column Controls */}
        <div className="flex flex-col gap-4">
          
          {/* Type */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant flex items-center gap-1">
              Type <span className="material-symbols-outlined text-[14px] text-primary rotate-45 select-none">push_pin</span>
            </span>
            <AppDropdown
              value={value.type || 'Regular'}
              onChange={(val) => patch('type', val)}
              options={typeOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* State */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">State</span>
            <AppDropdown
              value={value.state || 'Maharashtra'}
              onChange={(val) => patch('state', val)}
              options={stateOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* Transporter */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Transporter</span>
            <AppDropdown
              value={value.transporter || 'Select'}
              onChange={(val) => patch('transporter', val)}
              options={transporterOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* PAN */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">PAN</span>
            <input
              type="text"
              value={value.pan || ''}
              onChange={(e) => patch('pan', e.target.value)}
              placeholder="PAN Number..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* TDS */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">TDS</span>
            <AppDropdown
              value={value.tds || 'Select'}
              onChange={(val) => patch('tds', val)}
              options={tdsOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* TDSCode */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">TDSCode</span>
            <AppDropdown
              value={value.tdsCode || 'Select'}
              onChange={(val) => patch('tdsCode', val)}
              options={tdsCodeOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* AadhaarNo */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">AadhaarNo</span>
            <input
              type="text"
              value={value.aadhaarNo || ''}
              onChange={(e) => patch('aadhaarNo', e.target.value)}
              placeholder="12-digit Aadhaar Number..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* TCS */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">TCS</span>
            <AppDropdown
              value={value.tcs || '0%'}
              onChange={(val) => patch('tcs', val)}
              options={tcsOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* MSMEType */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">MSMEType</span>
            <AppDropdown
              value={value.msmeType || 'Select'}
              onChange={(val) => patch('msmeType', val)}
              options={msmeTypeOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* Category */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Category</span>
            <AppDropdown
              value={value.category || 'Select'}
              onChange={(val) => patch('category', val)}
              options={categoryOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* GTA */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">GTA</span>
            <div className="col-span-8 flex items-center h-10 select-none">
              <AppToggle
                checked={value.gta || false}
                onChange={(val) => patch('gta', val)}
              />
            </div>
          </div>

        </div>

        {/* Right Column Controls */}
        <div className="flex flex-col gap-4">
          
          {/* GST */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">GST</span>
            <div className="col-span-8 flex items-center rounded-xl border border-outline-variant/30 bg-surface-container-low overflow-hidden">
              <input
                type="text"
                value={value.gst || ''}
                onChange={(e) => patch('gst', e.target.value)}
                placeholder="GSTIN..."
                className="h-10 w-full bg-transparent px-4 text-sm text-on-surface outline-none border-0"
              />
              <button
                type="button"
                onClick={onGstVerifyClick || (() => patch('gst', ''))}
                className="h-10 px-3.5 bg-surface-container-high hover:bg-outline-variant/40 border-l border-outline-variant/20 flex items-center justify-center text-primary cursor-pointer transition select-none"
                aria-label="Verify GST"
              >
                <span className="material-symbols-outlined text-base">search</span>
              </button>
            </div>
          </div>

          {/* Pincode */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Pincode</span>
            <input
              type="text"
              value={value.pincode || ''}
              onChange={(e) => patch('pincode', e.target.value)}
              placeholder="Pincode..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* Distance */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Distance</span>
            <input
              type="number"
              value={value.distance ?? 0}
              onChange={(e) => patch('distance', parseInt(e.target.value) || 0)}
              placeholder="0"
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* TAN */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">TAN</span>
            <input
              type="text"
              value={value.tan || ''}
              onChange={(e) => patch('tan', e.target.value)}
              placeholder="TAN Number..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* TDSRate */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">TDSRate</span>
            <input
              type="number"
              value={value.tdsRate ?? 0}
              onChange={(e) => patch('tdsRate', parseFloat(e.target.value) || 0)}
              placeholder="0"
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* Resident */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Resident</span>
            <AppDropdown
              value={value.resident || 'Select'}
              onChange={(val) => patch('resident', val)}
              options={residentOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* CIN No */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">CIN No</span>
            <input
              type="text"
              value={value.cinNo || ''}
              onChange={(e) => patch('cinNo', e.target.value)}
              placeholder="CIN Number..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* MSMENo */}
          <label className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">MSMENo</span>
            <input
              type="text"
              value={value.msmeNo || ''}
              onChange={(e) => patch('msmeNo', e.target.value)}
              placeholder="MSME Reg No..."
              className="col-span-8 h-10 rounded-xl border border-outline-variant/30 bg-surface-container-low px-4 text-sm text-on-surface outline-none focus:ring-2 focus:ring-primary/20 transition"
            />
          </label>

          {/* Currency */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Currency</span>
            <AppDropdown
              value={value.currency || 'INR'}
              onChange={(val) => patch('currency', val)}
              options={currencyOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

          {/* Ledger */}
          <div className="grid grid-cols-12 gap-4 items-center">
            <span className="col-span-4 text-xs font-black uppercase tracking-wider text-on-surface-variant">Ledger</span>
            <AppDropdown
              value={value.ledger || 'None'}
              onChange={(val) => patch('ledger', val)}
              options={ledgerOptions}
              className="col-span-8"
              triggerClassName="h-10 bg-surface-container-low"
            />
          </div>

        </div>

      </div>
    </div>
  );
}
